__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ncm-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "18.1.3", () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "18.1.3", () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core/primitives/event-dispatch", "18.1.3", () => (__webpack_require__.e(745).then(() => (() => (__webpack_require__(6745))))));
			register("@angular/core/primitives/signals", "18.1.3", () => (__webpack_require__.e(689).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core/rxjs-interop", "18.1.3", () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(9074))))));
			register("@angular/core", "18.1.3", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(7580))))));
			register("@angular/platform-browser/animations", "18.1.3", () => (__webpack_require__.e(171).then(() => (() => (__webpack_require__(2552))))));
			register("@angular/platform-browser", "18.1.3", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(436))))));
			register("@angular/router", "18.1.3", () => (__webpack_require__.e(891).then(() => (() => (__webpack_require__(272))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};